import { render, staticRenderFns } from "./expertMatchingDetail.vue?vue&type=template&id=9b2997e2&scoped=true&"
import script from "./expertMatchingDetail.vue?vue&type=script&lang=js&"
export * from "./expertMatchingDetail.vue?vue&type=script&lang=js&"
import style0 from "./expertMatchingDetail.vue?vue&type=style&index=0&id=9b2997e2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b2997e2",
  null
  
)

export default component.exports